export default [
	{label: "Активен", value: 1},
	{label: "Отключен", value: 0},
]